import { useSearchParams, useNavigate } from "react-router-dom";

export default function EmailVerification() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const status = params.get("status");

  const config = {
    success: {
      title: "Email Verified",
      message: "Your email address was successfully verified.",
      icon: "✓",
      color: "green",
    },
    expired: {
      title: "Link Expired",
      message: "This verification link has expired.",
      icon: "⏰",
      color: "orange",
    },
    invalid: {
      title: "Invalid Link",
      message: "The verification link is no more valid.",
      icon: "✕",
      color: "red",
    },
    default: {
      title: "Verification Failed",
      message: "Something went wrong.",
      icon: "⚠",
      color: "red",
    },
  };

  const data =
    status && status in config
      ? config[status as keyof typeof config]
      : config.default;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white w-full max-w-sm rounded-xl shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div
            className={`w-16 h-16 rounded-full border-2 flex items-center justify-center text-3xl
            ${
              data.color === "green"
                ? "border-green-500 text-green-500"
                : data.color === "orange"
                ? "border-orange-500 text-orange-500"
                : "border-red-500 text-red-500"
            }`}
          >
            {data.icon}
          </div>
        </div>

        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          {data.title}
        </h2>

        <p className="text-sm text-gray-500 mb-6">
          {data.message}
        </p>

        {status === "success" && (
          <button
            onClick={() => navigate("/login")}
            className="w-full py-3 rounded-full bg-sky-500 hover:bg-sky-600 text-white font-medium transition"
          >
            Back to Login
          </button>
        )}
      </div>
    </div>
  );
}
